import { Stack, Typography } from '@mui/material';

interface PhrasesListProps {
    phrases: string[];
    emptyMessage?: string;
    labelId: string;
}

const PhrasesList: React.FC<PhrasesListProps> = ({ phrases, emptyMessage = 'No phrases available', labelId }) => (
    <Stack spacing={1}>
        {phrases.length > 0 ? (
            phrases.map((phrase, index) => (
                <Typography
                    key={`phrase-${index}`}
                    variant="body2"
                    sx={{
                        lineHeight: 1.4,
                        wordBreak: 'break-word',
                        fontStyle: 'italic',
                    }}
                    aria-labelledby={labelId}
                >
                    "{phrase}"
                </Typography>
            ))
        ) : (
            <Typography variant="body1" color="text.secondary">
                {emptyMessage}
            </Typography>
        )}
    </Stack>
);

export default PhrasesList;
